import react, { useCallback, useEffect, useMemo, useState } from "react";
import ManagePortsService from "../../services/managePorts.service";
import { setRequestVerificationPayload } from "../../interfaces/managePorts.interface";
import { throwGenericToasterError, toasterError } from "../../utils/methods";

export type moveToWaveXchangeType = {
  loading: boolean;
  moveToWaveXchange: () => void;
};

function useMoveToWaveXchange(
  portId: number | undefined,
  fetchPorts: (portId: number, isMounted: boolean) => void,
  isMounted: boolean,
  refetchIndex: () => void
): moveToWaveXchangeType {
  const [loading, setLoading] = useState<moveToWaveXchangeType["loading"]>(false);

  const moveToWaveXchange = useCallback(() => {
    if (!portId) return;
    setLoading(true);
    const payload: setRequestVerificationPayload = {
      nrIds: [portId],
    };
    ManagePortsService.setRequestVerification(payload)
      .then((result: any) => {
        fetchPorts(portId, isMounted);
        refetchIndex();
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        toasterError(e.message);
      });
  }, [portId]);
  const returnProps = useMemo(() => {
    return {
      loading,
      moveToWaveXchange,
    };
  }, [loading]);
  return returnProps;
}

export default useMoveToWaveXchange;
